import axios from 'axios';

export const DOCUMENT_UPLOAD_ERROR =
  'An unexpected error occurred while attempting to upload documents.';

export const NETWORK_ERROR_MESSAGE =
  "We couldn't reach the upload service. Please check your connection and try again.";

// uploadDocument() authenticates via a one-time upload_token query param, not
// the user's login session (no Authorization header on that call) — a 401
// here means the upload token expired/was invalid, not that the user got
// logged out. Session expiry is handled separately, globally, by the axios
// interceptor for requests that do carry an Authorization header.
export const UPLOAD_TOKEN_EXPIRED_MESSAGE =
  'Your document upload session expired. Please try uploading this file again.';

export const UNSUPPORTED_FILE_TYPE_MESSAGE =
  "This file type isn't supported. Please upload a JPG, PNG, HEIC, or PDF file.";

export const SERVER_ERROR_MESSAGE =
  'Something went wrong on our end while uploading your document. Please try again.';

export const getDocumentUploadErrorMessage = (
  error: unknown,
  fallbackMessage: string
): string => {
  if (!axios.isAxiosError(error)) {
    return fallbackMessage;
  }
  if (!error.response) {
    return NETWORK_ERROR_MESSAGE;
  }
  switch (error.response.status) {
    case 401:
      return UPLOAD_TOKEN_EXPIRED_MESSAGE;
    case 415:
      return UNSUPPORTED_FILE_TYPE_MESSAGE;
    case 500:
      return SERVER_ERROR_MESSAGE;
    default:
      return fallbackMessage;
  }
};
